<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  [isEmpty]="(skalReport$ | async)?.cropFields?.length === 0"
  [emptyTitle]="'noAdvices' | translate"
  [emptyDescription]="'noFields' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  [primaryActionText]="'printReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
>
  <agr-print-page
    [footerText]="'fertilizationWarningFooter' | translate"
    [relatedPeople]="relatedPeople$ | async"
    [marginLeft]="true"
    [showPageNumber]="false"
  >
    @if ((skalReport$ | async) !== null) {
      <div>
        <app-general-info [reportForLabel]="'skalReportFor'"></app-general-info>
        @if (tableConfigTotal?.dataSource?.filteredData?.length) {
          <div class="avoid-page-break spacing--margin-half-vertical spacing--padding-top">
            <h2 class="text--h3 layout--margin-horizontal">
              {{ 'planetProofFertilizers' | translate }}
            </h2>
            <div class="agr-table-name layout--margin-horizontal">
              {{ 'totalOrganicFields' | translate }} {{ (skalReport$ | async).totalArea }} Ha
            </div>
            <agr-table [config]="tableConfigTotal" data-test="skalTableTotal"></agr-table>
          </div>
        }
        @for (skalTable of skalTables; track skalTable) {
          <div>
            @if (skalTable.tableConfig?.dataSource?.filteredData?.length) {
              <div class="avoid-page-break spacing--margin-half-vertical">
                <div class="agr-table-name layout--margin-horizontal">
                  {{ skalTable.cropFieldName }}: {{ skalTable.cropName }}, {{ skalTable.area }} Ha
                </div>
                <agr-table [config]="skalTable.tableConfig" data-test="skalTable"></agr-table>
              </div>
            }
          </div>
        }
      </div>
    }
  </agr-print-page>
</agr-page-detail>
